import React, { Component } from "react";
import { getWizardData } from "../../../services/db";
import { checkParams, newSearchURL } from "./../../../components/Utils";
import queryString from "query-string";
import { Event } from "./../../Utils/index";

export class Footer extends Component {
  state = {
    steps: null,
    wizardData: null
  };

  componentDidMount() {
    const { location } = this.props;
    const wizardData = getWizardData(null, location);

    if (wizardData) {
      wizardData
        .then(data => {
          const steps = data && data.steps;

          this.setState({
            steps,
            wizardData: data
          });
        })
        .catch(error => {
          console.log("Error getting wizard data", error);
        });
    }
  }

  handleFooterMenuActive = index => {
    const { history, location } = this.props;
    const { pathname } = location;
    const stepParamURL = location && checkParams("step", location);

    const newURL = newSearchURL(
      `step=${stepParamURL}`,
      `step=${index.toString()}`,
      location
    );

    const stepToFind = `step${index.toString()}`;
    /**
     * If is not equal to step Colors, is not necessary put a value for this step
     */
    const findParam = queryString.parse(location.search)[stepToFind];

    let newURLFromMenuFooter = `${pathname}${newURL}`;
    if (!findParam && stepToFind !== "step1") {
      newURLFromMenuFooter = `${pathname}${newURL}&${stepToFind}=empty`;
    }

    history.push(newURLFromMenuFooter);
  };

  render() {
    const { wizardData } = this.state;
    const { location } = this.props;
    const stepParamURL = location && checkParams("step", location);
    const WIZARDVALIDATION =
      wizardData && wizardData.steps && wizardData.steps.length > 0;

    return (
      <div data-test="FooterComponent" className="">
        <div className="row mg-left-0 mg-right-0 center-xs footer-wizard-indicator-step">
          <div
            className={`col-3 col-md-12 footer-wizard-indicator-step--col ${
              parseInt(stepParamURL) === 1 ? "footerWizardItemActive" : ""
            }`}
            onClick={() => {
              this.handleFooterMenuActive(1);
              Event("STEP", "Usuario dió click en paso 1", "STEP_INDEX");
            }}
          >
            <div>
            <button className="d-flex d-md-block">
              <div >
                <p className="indicator-step-number"><strong>1</strong><span className="d-block indicator-step-literal">Color</span></p>
              </div>
              <i className="fas fa-chevron-right hide-md d-inline d-md-none"></i>
              <i className="fas fa-chevron-down hide-xs show-md"></i>
            </button>
             </div>
          </div>
          {WIZARDVALIDATION &&
            wizardData.steps.map((step, index) => {
              return (
                <div
                  key={step.ID}
                  className={`col-3 col-md-12 footer-wizard-indicator-step--col ${
                    parseInt(stepParamURL) === index + 2
                      ? "footerWizardItemActive"
                      : ""
                  }`}
                >
                  <div
                    onClick={() => {
                      parseInt(stepParamURL) !== index + 2 &&
                        this.handleFooterMenuActive(index + 2);
                      Event(
                        "STEP",
                        `Usuario dió click en paso ${index + 2}`,
                        "STEP_INDEX"
                      );
                    }}
                  >
                    <button className="d-flex d-md-block">
                      <div
                        dangerouslySetInnerHTML={{ __html: step.post_content }}
                      />
                      <i className="fas fa-chevron-down hide-xs show-md"></i>
                      <i className="fas fa-chevron-right hide-md"></i>
                    </button>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    );
  }
}

export default Footer;
